import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Logo } from './Logo';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-0 w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-gray-900/95 backdrop-blur-xl border-b border-white/10' : 'bg-transparent'}`} data-id="element-161">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl flex justify-between items-center py-4" data-id="element-162">
        <Logo data-id="element-163" />
        <nav className="hidden md:flex space-x-8 items-center" data-id="element-164">
          <a href="#features" className="text-gray-300 hover:text-white font-medium transition-colors" data-id="element-165">
            Features
          </a>
          <a href="#showcase" className="text-gray-300 hover:text-white font-medium transition-colors" data-id="element-166">
            Product
          </a>
          <a href="#pricing" className="text-gray-300 hover:text-white font-medium transition-colors" data-id="element-167">
            Pricing
          </a>
          <a href="#faq" className="text-gray-300 hover:text-white font-medium transition-colors" data-id="element-168">
            FAQ
          </a>
          <a href="#pricing" className="bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-500 hover:to-blue-500 text-white px-6 py-2.5 rounded-lg font-medium transition-all shadow-lg shadow-purple-500/25" data-id="element-169">
            Get started
          </a>
        </nav>
        <button className="md:hidden text-white" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-170">
          {isMenuOpen ? <X className="h-6 w-6" data-id="element-171" /> : <Menu className="h-6 w-6" data-id="element-172" />}
        </button>
      </div>
      {isMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-gray-900 border-t border-white/10 shadow-xl py-4 px-4 flex flex-col space-y-4" data-id="element-173">
          <a href="#features" className="text-gray-300 hover:text-white font-medium transition-colors" data-id="element-174">
            Features
          </a>
          <a href="#showcase" className="text-gray-300 hover:text-white font-medium transition-colors" data-id="element-175">
            Product
          </a>
          <a href="#pricing" className="text-gray-300 hover:text-white font-medium transition-colors" data-id="element-176">
            Pricing
          </a>
          <a href="#faq" className="text-gray-300 hover:text-white font-medium transition-colors" data-id="element-177">
            FAQ
          </a>
          <a href="#pricing" className="bg-gradient-to-r from-purple-600 to-blue-600 text-white px-6 py-2.5 rounded-lg font-medium transition-all text-center" data-id="element-178">
            Get started
          </a>
        </div>}
    </header>;
}